import { render, staticRenderFns } from "./siteOrderAll.vue?vue&type=template&id=12bc77cf&scoped=true&"
import script from "./siteOrderAll.vue?vue&type=script&lang=js&"
export * from "./siteOrderAll.vue?vue&type=script&lang=js&"
import style0 from "./siteOrderAll.vue?vue&type=style&index=0&id=12bc77cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc77cf",
  null
  
)

export default component.exports